import { absolutePath } from "./absolutePath";

export interface EmailHubContactsUsageParams {
  page?: number;
  per_page?: number;
}

interface EmailHubContactsUsageFnProps {
  params?: EmailHubContactsUsageParams;
}

export const emailHubContactsUsage = {
  list: ({ params }: EmailHubContactsUsageFnProps = {}) =>
    absolutePath("email_hub/contacts_usage", params),
};
